const PZPType = {
    PZP_OLD: "PZP_old",
    PZP_2021: "PZP_2021"
};

export default PZPType;